import { Notification } from "./Notification";
import { UIWidget } from "./UiWidget";

export function UIWidgetGroup(pData) {
  Notification.call(this);

  this.mWidgets = [];
  this.mName = '';

  if (pData) {
    this.fromJson(pData);
  }
}

UIWidgetGroup.prototype = Object.create(Notification.prototype);

UIWidgetGroup.prototype.fromJson = function(pJson) {
  if (pJson.name) {
    this.mName = pJson.name;
  }

  if (pJson.widgets) {
    this.mWidgets = pJson.widgets.map(function(pJsonWidget) {
      return new UIWidget(pJsonWidget.type, pJsonWidget);
    });
  }
};

UIWidgetGroup.prototype.getName = function() { return this.mName; };
UIWidgetGroup.prototype.setName = function(pName) {
  this.mName = pName;

  this.notify('onNameChanged', this.mName);
};

UIWidgetGroup.prototype.toJson = function() {
  return {
    name: this.mName,
    widgets: this.mWidgets.map(function(pWidget) {
      return pWidget.toJson();
    })
  };
};

UIWidgetGroup.prototype.listWidgets = function() { return this.mWidgets; };
UIWidgetGroup.prototype.addWidget = function(pType, pWidgetIndex) {
  const lWidget = new UIWidget(pType);

  if (pWidgetIndex === undefined) {
    pWidgetIndex = this.mWidgets.length;
    this.mWidgets.push(lWidget);
  } else {
    this.mWidgets.splice(pWidgetIndex, 0, lWidget);
  }

  this.notify('onWidgetAdded', lWidget, pWidgetIndex);
  return lWidget;
};

UIWidgetGroup.prototype.removeWidget = function(pWidget) {
  const lWidgetIndex = this.mWidgets.findIndex(function(pExisting) { return pExisting === pWidget; });
  this.removeWidgetByIndex(lWidgetIndex);
};

UIWidgetGroup.prototype.removeWidgetByIndex = function(pWidgetIndex) {
  const lRemovedWidget = this.mWidgets.splice(pWidgetIndex, 1);
  if (lRemovedWidget.length === 1) {
    this.notify('onWidgetRemoved', lRemovedWidget[0], pWidgetIndex);
    return true;
  }

  console.error('Unable to remove widget at index: ' + pWidgetIndex);
  return false;
};

UIWidgetGroup.prototype.getWidgetByIndex = function(pIndex) {
  if (pIndex >= 0 && pIndex < this.mWidgets.length) {
    return this.mWidgets[pIndex];
  }

  console.error('Unable to get widget at index: ' + pIndex);
  return undefined;
};

UIWidgetGroup.prototype.getWidgetIndex = function(pWidget) {
  return this.mWidgets.find(function(pOtherWidget) { return pOtherWidget === pWidget; });
};
